import { CheckItem } from "../../../components/checkbox-block/checkbox-block.component";

export const userPermissionList: CheckItem[] = [
  { id: 3, name: "USERS_VIEW", state: false },
  { id: 4, name: "USERS_ADD", state: false },
  { id: 5, name: "USERS_EDIT", state: false },
  { id: 6, name: "USERS_BLOCK", state: false },
  { id: 7, name: "USERS_DELETE", state: false },
  { id: 8, name: "USERS_RESET_PASSWORD", state: false },
  { id: 9, name: "USERS_LIST", state: false },
  { id: 10, name: "USERS_RESET_SESSION", state: false },
];

export const rolePermissionList: CheckItem[] = [
  { id: 14, name: "ROLES_VIEW", state: false },
  { id: 15, name: "ROLES_ADD", state: false },
  { id: 16, name: "ROLES_EDIT", state: false },
  { id: 17, name: "ROLES_DELETE", state: false },
];

export const virtualPosPermissionList: CheckItem[] = [
  { id: 26, name: "VIRTUAL_POS_VIEW", state: false },
  { id: 27, name: "VIRTUAL_POS_EDIT", state: false },
  { id: 28, name: "VIRTUAL_POS_COMMISSION_VIEW", state: false },
  { id: 29, name: "VIRTUAL_POS_BLOCK", state: false },
  { id: 30, name: "VIRTUAL_POS_DELETE", state: false },
];

export const paymentLinksPermissionList: CheckItem[] = [
  { id: 32, name: "LINKS_VIEW", state: false },
  { id: 33, name: "LINKS_ADD", state: false },
  { id: 34, name: "LINKS_EDIT", state: false },
  { id: 35, name: "LINKS_DELETE", state: false },
  { id: 36, name: "LINKS_SEND", state: false },
  { id: 37, name: "LINKS_LIST", state: false },
];

export const savedCardPermissionList: CheckItem[] = [
  { id: 38, name: "CARDS_VIEW", state: false },
  { id: 39, name: "CARDS_ADD", state: false },
  { id: 40, name: "CARDS_BLOCK", state: false },
  { id: 41, name: "CARDS_DELETE", state: false },
];

export const supportPermissionList: CheckItem[] = [
  { id: 118, name: "SUPPORT_VIEW", state: false },
  { id: 119, name: "SUPPORT_ADD", state: false },
  { id: 11, name: "SUPPORT_EDIT", state: false },
];

export const recurringPaymentPermissionList: CheckItem[] = [
  { id: 23, name: "RECURRING_PAYMENT_VIEW", state: false },
  { id: 24, name: "RECURRING_PAYMENT_LIST", state: false },
  { id: 25, name: "RECURRING_PAYMENT_BLOCK", state: false },
];

export const refundPermissionList: CheckItem[] = [
  { id: 21, name: "REFUND_VIEW", state: false },
  { id: 22, name: "REFUND_LIST", state: false },
];

export const paymentPermissionList: CheckItem[] = [
  { id: 18, name: "PAYMENT_VIEW", state: false },
  { id: 19, name: "PAYMENT_LIST", state: false },
  { id: 20, name: "PAYMENT_REFUND", state: false },
];

export const terminalsPermissionList: CheckItem[] = [{ id: 31, name: "TERMINALS_VIEW", state: false }];

export const p2pPermissionList: CheckItem[] = [{ id: 42, name: "P2P_OPERATION", state: false }];

export const infoPermissionList: CheckItem[] = [
  { id: 1, name: "INFORMATION_VIEW", state: false },
  { id: 2, name: "INFORMATION_EDIT", state: false },
];

export const paymentViewPermissionList: CheckItem[] = [
  { id: 43, name: "PAYMENT_TYPE_VIEW", state: false },
  { id: 44, name: "PAYMENT_TYPE_ADD", state: false },
  { id: 45, name: "PAYMENT_TYPE_EDIT", state: false },
  { id: 46, name: "PAYMENT_TYPE_BLOCK", state: false },
  { id: 110, name: "PAYMENT_TYPE_DELETE", state: false },
];

export const analyticsPermissionList: CheckItem[] = [{ id: 121, name: "ANALYTICS_VIEW", state: false }];
